import axios from "axios"

const controller = "/proyecto"

const ProyectoService = {
    buscar: async (proyecto) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            proyecto
        })
        return data
    },
    registrar: async (proyecto) => {
        const { data } = await axios.post(`${controller}/registrar`, {
            proyecto
        })
        return data
    },
    obtener: async (pry_id) => {
        const { data } = await axios.post(`${controller}/obtener`, {
            proyecto: {
                pry_id
            }
        })
        return data
    },
    modificar: async (proyecto) => {
        const { data } = await axios.post(`${controller}/modificar`, {
            proyecto
        })
        return data
    },
    paginarEmpleadosAsignados: async (request) => {
        const { data } = await axios.post(`${controller}/paginarEmpleadosAsignados`, request)
        return data
    },
    asignarEmpleados: async (request) => {
        const { data } = await axios.post(`${controller}/asignarEmpleados`, request)
        return data
    }
}

export default ProyectoService